import { render, staticRenderFns } from "./RoleUpdate.vue?vue&type=template&id=36d3d6f0"
import script from "./RoleUpdate.vue?vue&type=script&lang=js"
export * from "./RoleUpdate.vue?vue&type=script&lang=js"
import style0 from "./RoleUpdate.vue?vue&type=style&index=0&id=36d3d6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports